export const CONTACT = {
  address: "1064 Budapest, Podmaniczky utca 75.",
  phone: "(1) 227 2953",
  phoneHref: "tel:+3612272953",
  email: "info@shutentattoostudio.com",
  instagram: "https://instagram.com/shuten_tattoo_studio_",
  instagramHandle: "@shuten_tattoo_studio_",
  facebook: "https://facebook.com/shutentattoostudio",
  mapsEmbed: "https://www.google.com/maps?q=1064%20Budapest%20Podmaniczky%20utca%2075&output=embed",
};


export const PIERCING_PRICES = [
  { name: "Cimpa", price: 7000, group: "Fül" },
  { name: "Helix", price: 8000, group: "Fül" },
  { name: "Rook", price: 8000, group: "Fül" },
  { name: "Conch", price: 8000, group: "Fül" },
  { name: "Industrial", price: 10000, group: "Fül" },
  { name: "Daith", price: 10000, group: "Fül" },
  { name: "Tragus", price: 8000, group: "Fül" },
  { name: "Szemöldök", price: 8000, group: "Arc" },
  { name: "Anti eyebrow", price: 8000, group: "Arc" },
  { name: "Nyelv", price: 10000, group: "Arc" },
  { name: "Orr", price: 8000, group: "Arc" },
  { name: "Szeptum", price: 8000, group: "Arc" },
  { name: "Bridge", price: 10000, group: "Arc" },
  { name: "Köldök", price: 8000, group: "Test" },
  { name: "Mell", price: 10000, group: "Test" },
  { name: "Surface", price: 10000, group: "Test" },
  { name: "Intim", price: 12000, group: "Intim" },
];

export const PIERCING_GROUPS = ["Mind", "Fül", "Arc", "Test", "Intim"];

export const formatFt = (n) => `${String(n).replace(/\B(?=(\d{3})+(?!\d))/g, " ")} Ft`;

export const NAV_LINKS = [
  { to: "/", label: "Főoldal" },
  { to: "/muveszek", label: "Tetoválóink" },
  { to: "/piercing", label: "Piercing" },
  { to: "/arak", label: "Árak" },
  { to: "/galeria", label: "Galéria" },
  { to: "/termekek", label: "Termékek" },
  { to: "/kapcsolat", label: "Kapcsolat" },
];
